// Auto-generated by splitter.py — do not regenerate; edit directly.

import React, { useEffect } from 'react';
import { X } from 'lucide-react';

export const Drawer = ({ open, onClose, title, subtitle, status, children, actions, width = 'w-[560px]' }) => {
  useEffect(() => {
    if (!open) return undefined;
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') onClose?.();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [open, onClose]);

  return (
    <>
      {open && (
        <div className="fixed inset-0 bg-black/20 z-40 transition-opacity" onClick={onClose} />
      )}
      <div
        className={`fixed top-0 right-0 h-screen ${width} bg-white border-l border-[#E6E4E1] z-50 transform transition-transform duration-200 shadow-[-8px_0_24px_-12px_rgba(0,0,0,0.08)] flex flex-col ${
          open ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <div className="px-6 pt-5 pb-4 border-b border-[#E6E4E1] flex-shrink-0">
          <div className="flex items-start justify-between gap-3">
            <div className="min-w-0 flex-1">
              <div className="text-[10.5px] tracking-[0.08em] font-semibold uppercase text-[#9CA3AF] mb-1">{subtitle}</div>
              <div className="text-[17px] font-semibold tracking-[-0.01em] text-[#1F2937] truncate">{title}</div>
              {status && <div className="mt-2">{status}</div>}
            </div>
            <button type="button" aria-label="Close" onClick={onClose} className="w-8 h-8 rounded-md hover:bg-[#F2F1ED] flex items-center justify-center flex-shrink-0">
              <X className="w-4 h-4 text-[#6B7280]" strokeWidth={1.75} />
            </button>
          </div>
        </div>
        <div className="flex-1 overflow-y-auto">
          {children}
        </div>
        {actions && (
          <div className="border-t border-[#E6E4E1] px-5 py-2.5 flex items-center justify-end gap-1.5 gap-y-2 flex-wrap bg-[#FBFAF7] flex-shrink-0">
            {actions}
          </div>
        )}
      </div>
    </>
  );
};


export const DrawerSection = ({ title, children, action }) => (
  <div className="px-6 py-4 border-b border-[#E6E4E1] last:border-b-0">
    <div className="flex items-center justify-between mb-3">
      <div className="text-[10.5px] tracking-[0.08em] font-semibold uppercase text-[#6B7280]">{title}</div>
      {action}
    </div>
    {children}
  </div>
);


export const DrawerActions = ({ children }) => (
  <div className="px-5 py-3 border-t border-[#E6E4E1] bg-[#FBFAF7] flex items-center justify-between gap-2 sticky bottom-0">
    {children}
  </div>
);
